import React, { ReactElement } from 'react';
import Link from 'next/link';
import classNames from 'classnames/bind';
import styles from 'sections/DigitalTools/components/SectionInfo/SectionInfo.module.scss';

const cn = classNames.bind(styles);

const SectionInfo = (): ReactElement => {
  return (
    <section className={cn('info')}>
      <div className={cn('container')}>
        <div className={cn('info__content')}>
          <h2 className={cn('info__heading')}>Digital Logistics Tools for Premium Members</h2>
          <p className={cn('info__description')}>
            <span className={cn('is-bold')}>Digital tools for logistics</span> are crucial for
            <Link className={cn('info__description-link')} href='/freight-forwarder'> freight forwarders </Link> as they enhance operational
            efficiency and provide real-time visibility into supply chain activities. They enable accurate
            tracking and management of shipments, leading to timely deliveries and improved customer
            satisfaction.
          </p>
          <p className={cn('info__description')}>
            Premium Members receive 3 unique digital solutions. These are Logistics Explorer, Tracking System, Ship Schedules. 
            Standard members receive an opportunity to integrate Logistics Explorer branded under SeaRates into their website as well.
          </p>
          <h2 className={cn('info__heading')}>Why invest in these digital tools?</h2>
          <p className={cn('info__description')}>
            <span className={cn('is-bold')}>Investing in digital tools </span> is essential for modern businesses seeking to optimize their
            operations and stay competitive. These tools streamline processes, reduce manual errors, and
            increase overall efficiency, leading to significant cost savings. <span className={cn('is-bold')}>Real-time data and analytics </span>
            provide valuable insights, enabling informed decision-making and proactive problem-solving.
            Enhanced visibility into supply chains and logistics ensures timely deliveries and improved
            customer satisfaction. Furthermore, digital tools facilitate scalability and adaptability, allowing
            businesses to grow and adjust to market demands easily.
          </p>
        </div>
      </div>
    </section>
  );
};

export default SectionInfo;